import { useEffect, useState } from 'react';

const getIsMobile = (customSize: number) => window.innerWidth <= customSize;

const DEFAULT_MOBILE_SCREEN_SIZE = 991;

const useIsMobile = (customSize = DEFAULT_MOBILE_SCREEN_SIZE): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(getIsMobile(customSize));

  useEffect(() => {
    const handleResize = () => (window.innerWidth <= customSize
      ? setIsMobile(true)
      : setIsMobile(false));

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
